import {
  AdminInput,
  Button,
  DeleteIcon,
  Div,
  ErrorToast,
  H3,
  Modal,
  P,
  PropsModal,
  SuccessToast,
  UnpaidReportOrdersModal,
  deleteBrandById,
  deleteLocationById,
  reportError,
  useUnpaidReportOrders,
} from '@vgrubs/components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const DeleteLocationBrandModal = ({
  isOpen,
  closeModal,
  setLoading,
  type,
}: PropsModal & {
  isOpen: string | number | null;
  type: 'locations' | 'brands';
}) => {
  const navigate = useNavigate();
  const [deleteText, setDeleteText] = useState('');
  const unpaidReportOrders = useUnpaidReportOrders();

  const id = isOpen;
  const deleteFunction =
    type === 'locations' ? deleteLocationById : deleteBrandById;

  async function deleteLocation(confirmUnpaidOrders?: boolean) {
    if (!id) return;
    if (deleteText !== 'DELETE')
      return ErrorToast('Please enter DELETE in the field below');
    try {
      setLoading?.(true);
      const { data } = await deleteFunction(id, confirmUnpaidOrders);
      SuccessToast(data.message);
      setLoading?.(false);
      navigate(-1);
    } catch (error) {
      // Orders still waiting for their provider payment report get paid out
      // from the subtotal, but only once the admin has seen and confirmed them.
      if (!unpaidReportOrders.intercept(error, () => deleteLocation(true)))
        reportError(error);
      setLoading?.(false);
    }
  }

  return (
    <>
      <Modal
        isOpen={!!isOpen && !unpaidReportOrders.pending}
        closeModal={closeModal}
        logo={false}
        exitButton={false}
      >
        <Div $mb="16">
          <DeleteIcon />
        </Div>

        <H3 $m="10px" $center $capitalize>
          Delete {type === 'locations' ? 'Location' : 'Brand'}
        </H3>
        <P $mb="24" $center>
          If you want to delete your{' '}
          {type === 'locations' ? 'location' : 'brand'} enter DELETE in field
          below?
        </P>

        <AdminInput
          placeholder="Enter Here"
          $textCenter
          value={deleteText}
          onChange={({ target }) => setDeleteText(target.value)}
        />

        <Div $flex $gap="16px" $mt="32">
          <Button onClick={() => deleteLocation()} $w="100%" $selected>
            Confirm
          </Button>
          <Button $w="100%" onClick={closeModal} $gray $selected>
            Cancel
          </Button>
        </Div>
      </Modal>
      <UnpaidReportOrdersModal
        pending={unpaidReportOrders.pending}
        closeModal={unpaidReportOrders.close}
      />
    </>
  );
};
